import { useState } from 'react'
import { useModals } from '../contexts/ModalContext.jsx'

export function FounderModal() {
  const { founderOpen, closeFounder } = useModals()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [done, setDone] = useState(false)

  if (!founderOpen) return null

  function resetAndClose() {
    closeFounder()
    setTimeout(() => {
      setName('')
      setEmail('')
      setDone(false)
    }, 200)
  }

  function submit(e) {
    e.preventDefault()
    if (!name.trim() || !email.trim()) return
    setDone(true)
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-6">
      <button type="button" className="absolute inset-0 cursor-default" aria-label="Close" onClick={resetAndClose} />
      <div className="relative z-10 w-full max-w-md rounded-t-3xl bg-white p-6 shadow-2xl sm:rounded-3xl sm:p-8">
        <div className="mb-4 flex items-start justify-between">
          <div>
            <div className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-plum-600">
              Founding Members
            </div>
            <h3 className="mt-2 font-display text-[24px] font-black text-stone-950">
              Reserve founder pricing
            </h3>
          </div>
          <button type="button" onClick={resetAndClose} className="text-2xl leading-none text-stone-400">
            ×
          </button>
        </div>

        {done ? (
          <div className="rounded-2xl bg-teal-50 p-5 text-center">
            <div className="text-[18px] font-extrabold text-teal-700">You&apos;re on the list</div>
            <p className="mt-2 text-[14px] text-stone-600">
              We&apos;ll reach out shortly with next steps to lock in your founder rate.
            </p>
            <button
              type="button"
              onClick={resetAndClose}
              className="mt-5 rounded-[10px] bg-teal-600 px-6 py-3 text-[14px] font-extrabold text-white"
            >
              Close
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <p className="text-[14px] text-stone-600">
              Lock in $199/mo semaglutide or $249/mo tirzepatide for as long as you stay enrolled.
            </p>
            <label className="block">
              <span className="text-[12px] font-bold uppercase tracking-wider text-stone-400">Name</span>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="mt-1.5 w-full rounded-xl border border-stone-200 px-4 py-3 text-[15px] outline-none focus:border-teal-500"
                required
              />
            </label>
            <label className="block">
              <span className="text-[12px] font-bold uppercase tracking-wider text-stone-400">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full rounded-xl border border-stone-200 px-4 py-3 text-[15px] outline-none focus:border-teal-500"
                required
              />
            </label>
            <button
              type="submit"
              className="mt-2 rounded-[10px] bg-plum-600 py-3.5 text-[15px] font-extrabold text-white"
            >
              Reserve my spot
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
